<template>
  <Photos year="2012" :min-date="1330992000" :max-date="1331164800" date-text="March 6&ndash;8" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
